/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */

const documentTileStyle = {
  largeContainer: {
    maxWidth: "257px",
    minHeight: "361px",
  },
  smallContainer: {
    width: "140px",
    height: "190px",
  },
  minimalContainer: {
    width: "105px",
    height: "142px",
  },
  narrowText: {
    width: "130px",
    wordBreak: "break-all",
  },
  minimalText: {
    width: "95px",
    wordBreak: "break-all",
  },
  container: {
    margin: "0 auto 0 auto",
    width: "95%",
    border: "1px solid #dedcdc",
    borderRadius: "5px",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    "&:hover": {
      cursor: "pointer",
    },
  },
  button: {
    borderTop: "1px solid #dedcdc",
    borderBottom: "1px solid #dedcdc",
    borderRadius: 0,
    padding: ".875rem",
    background: "rgba(255, 255, 255, 0.6)",
    "&:hover": {
      backgroundColor: "rgba(200, 200, 200, 0.8)",
      cursor: "pointer",
    },
  },
  title: {
    padding: "1rem 1rem 1.25rem 1rem",
  },
  icon: {
    width: "40px",
    height: "40px",
  },
};

export default documentTileStyle;
